<template>
  <div class="app-preview-content">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'AppPreviewContent',
    inject: ['previewData']
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .app-preview-content {
    min-height: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    align-items: center;
  }
</style>
